import React, { useEffect } from 'react';
import RegisterForm from '../pages/RegisterFlow/Register.jsx';
import registerImage from "../assets/images/register-image.jpg";
import './Register.css';

const Register = () => {

  useEffect(() => {
    document.title += ' - Register';
    // This will clean up the title when component unmounts
    return () => {
      document.title = 'CVance'; // Default title
    };
  }, []);

  return (
    <div className="auth-page">
      <div className="container">
        <div className="auth-container">
          <div className="register-image">
            <img src={registerImage} className='image'>
            </img>
          </div>
          <div className="auth-content">
            <RegisterForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;